import { useParams } from 'react-router-dom';

import { useDomainNameVerificationQuery } from '@dashboard/generated/wp/platform';

export function useCurrentDomainNameVerificationId() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    throw new Error('Domain name verification ID is required');
  }
  return id;
}

export function useCurrentDomainNameVerificationQuery() {
  const id = useCurrentDomainNameVerificationId();
  return useDomainNameVerificationQuery({ variables: { id } });
}
